// A phone's screen stays on through a game: waiting for three others to play is when it dims, and a tap to wake it has been known to
// discard (design 10 §8). A touch device only, and only while `on` says; the browser drops the lock when the page is hidden.

import { createEffect, onCleanup } from "solid-js";

export function keepAwake(on: () => boolean): void {
  createEffect(() => {
    if (!on() || typeof navigator === "undefined" || !navigator.wakeLock || !matchMedia("(pointer: coarse)").matches) return;
    let lock: WakeLockSentinel | null = null;
    let done = false;
    const take = () => {
      if (document.hidden || lock) return;
      navigator.wakeLock.request("screen").then(
        (l) => {
          if (done) return void l.release();
          lock = l;
          l.addEventListener("release", () => (lock = null));
        },
        () => {}, // refused (low battery, a policy): the screen does what it would have done
      );
    };
    take();
    document.addEventListener("visibilitychange", take);
    onCleanup(() => {
      done = true;
      document.removeEventListener("visibilitychange", take);
      void lock?.release();
    });
  });
}
